import type { SVGProps } from "react";
import * as React from "react";
const SvgDustLogoMono = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 24"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12 0 6.627 5.373 12 12 12s12-5.373 12-12v12h12a6 6 0 0 0 0-12h12v12h12V12h12V0H60a6 6 0 0 0 0 12H48V0H24v12c0-6.627-5.373-12-12-12H0v24h12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDustLogoMono;
